"use client";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import IconButtonField from "../Button/IconButtonField";
import Menus from "../Menu/Menu";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import Avatars from "../Avatar/Avatars";
import "./AppBar.scss";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import { SvgIcon } from "@mui/material";
import AlterDialog from "../AlterDialog/AlterDialog";
import ButtonField from "../Button/ButtonField";
import { useState } from "react";
import { EditStudentExam } from "../../Redux/Slices/StudentExam/EditStudentExamSlice";
import { EditStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import UserProfileSection from "../UserProfileSection/UserProfileSection";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../../Pages/Login/ILogin";
import { useEffect } from "react";

export default function AppBarnav() {
  const nav = useNavigate();
  const location = useLocation();
  const { state: exam_id } = location;
  const currentPath: any = location.pathname;

  const [ishome, setIshome] = useState<boolean>(false);
  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);
  const PendingTime = sessionStorage.getItem("pending_time");
  const Response = sessionStorage.getItem("response");
  const question_id = Number(sessionStorage.getItem("question_id"));
  const Question_Type = Number(sessionStorage.getItem("question_type"));
  const StudentExamId = Number(sessionStorage.getItem("student_exam_id"));
  const { data: PopupStudentExamSlice } = useAppSelector(
    (state) => state.PopupStudentExamSlice
  );
  const dispatch = useAppDispatch();
  const Popupdisable = PopupStudentExamSlice;

  const { data: listexamlist } = useAppSelector(
    (state) => state.ListExamIDSlice
  );

  const pathNameMap: any = {
    "/dashboard": "Dashboard",
    "/practicetest": "Practice Test",
    "/mockexam": "Mini Mock Exam",
    "/minimockexam": "Mock Exam",
    "/mainexam": "Exam",
    "/examprogress": "Exam in Progress",
    "/examhistory": "Exam History",
    "/skillstrainer": "Skills Trainer",
    "/memorygame": "Memory Game",
    "/totalexam": "My Enrollments",
    "/subscribedPages": "My Enrollments / Package",
    "/setting": "Settings",
    "/tutorials": "Video Tutorials",
    "/videolessons": "Video Lessons",
  };

  const pageTitle = pathNameMap[currentPath] ||
    currentPath.split('/').pop()?.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') || "Page";

  const List: any = listexamlist?.data?.exam_name;
  const Listdata: any = listexamlist?.data;

  return (
    <>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar className="appbarname">
            <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <Typography variant="h6" noWrap component="div">
                <SvgIcon
                  sx={{
                    width: "123px",
                    height: "50px",
                    marginTop: "10px",
                    cursor: exam_id?.examID ? "pointer" : "default",
                  }}
                  color="primary"
                  component={Logo}
                  inheritViewBox
                  onClick={() => {
                    if (exam_id?.examID) {
                      if (List === "Mini Mock Test") {
                        nav("/dashboard");
                      } else {
                        setIshome(true);
                      }
                    }
                  }}
                />
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#4779ff",
                  fontSize: { xs: "1rem", md: "1.25rem" },
                }}
              >
                {pageTitle}
              </Typography>
            </Box>

              <UserProfileSection />
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
        </Box>
      </Box>
      <AlterDialog
        alterheading={"Warning"}
        alterableName={
          "You are currently in the middle of the examination. Please complete it and move forward, or resume the exam from the 'Exams in Progress' section until time is up"
        }
        open={ishome}
        setOpen={setIshome}
        buttonname={
          <>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                if (exam_id?.Practice) {
                  dispatch(
                    EditStudentExamPractice({
                      pending_time: PendingTime,
                      student_test_id: StudentExamId,
                      question_type_id: Question_Type,
                      question_id: question_id,
                      response: Response,
                    })
                  );
                } else {
                  dispatch(
                    EditStudentExam({
                      pending_time: PendingTime,
                      student_exam_id: StudentExamId,
                      question_type_id: Question_Type,
                      question_id: question_id,
                      sentence: Response,
                    })
                  );
                }
                sessionStorage.removeItem("pending_time");
                sessionStorage.removeItem("response");
                sessionStorage.removeItem("question_id");
                sessionStorage.removeItem("question_type");
                sessionStorage.removeItem("student_exam_id");

                nav("/dashboard");
                setIshome(false);
              }}
            >
              Yes
            </ButtonField>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setIshome(false);
              }}
            >
              No
            </ButtonField>
          </>
        }
      />
    </>
  );
}
